import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { MobileCTA } from "@/components/MobileCTA";
import { CookieNotice } from "@/components/CookieNotice";
import { ScrollToTop } from "@/components/ScrollToTop";
import { Accreditations } from "@/components/Accreditations";
import Home from "@/pages/Home";
import HeatPumps from "@/pages/HeatPumps";
import BoilerUpgradeScheme from "@/pages/BoilerUpgradeScheme";
import AboutUs from "@/pages/AboutUs";
import Faqs from "@/pages/Faqs";
import Contact from "@/pages/Contact";
import { PrivacyPolicy, CookiePolicy, TermsAndConditions, Complaints } from "@/pages/Legal";

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.11, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <BrowserRouter>
            <ScrollToTop />
            <div className="flex min-h-screen flex-col bg-white font-sans text-slate-900">
                <Header />
                <main className="flex-1">
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/heat-pumps" element={<HeatPumps />} />
                        <Route path="/boiler-upgrade-scheme" element={<BoilerUpgradeScheme />} />
                        <Route path="/about-us" element={<AboutUs />} />
                        <Route path="/faqs" element={<Faqs />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                        <Route path="/cookie-policy" element={<CookiePolicy />} />
                        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
                        <Route path="/complaints" element={<Complaints />} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </main>
                <Accreditations />
                <Footer />
                <MobileCTA />
                <CookieNotice />
                <Toaster position="top-center" richColors />
            </div>
        </BrowserRouter>
    );
}

export default App;
